;(function () {
  angular.module('contrast.avatar').directive('avatarDisplay', avatarDisplay)

  function avatarDisplay(
    $rootScope,
    avatarFactory,
    DEFAULT_AVATAR,
    CONTRAST_AVATAR,
    CONTRAST_AVATAR_WHITE,
    GLOBAL_EVENTS
  ) {
    'ngInject'

    return {
      restrict: 'EA',
      scope: {
        size: '=',
        user: '=',
        useContrastLogo: '='
      },
      template:
        '<div class="avatar-display-container" data-e2e="user-avatar"><img ng-src="{{avatarUrl}}"/></div>',
      replace: true,
      link: link
    }

    function link(scope, element) {
      var imageEl = element.find('img'),
        size = scope.size ? parseInt(scope.size) : 26,
        userUid = scope.user,
        useContrastLogo = angular.isDefined(scope.useContrastLogo)

      imageEl.css('visibility', 'hidden')

      if (userUid || useContrastLogo) {
        getAvatar(scope, imageEl, size, userUid, useContrastLogo)
      }

      scope.$watch('user', function (newVal, oldVal) {
        if (newVal && newVal != oldVal) {
          userUid = newVal
          getAvatar(scope, imageEl, size, userUid, useContrastLogo)
        }
      })

      // TODO: CONTRAST-18296
      // eslint-disable-next-line angular/on-watch
      $rootScope.$on(GLOBAL_EVENTS.AVATAR_UPDATE, function () {
        getAvatar(scope, imageEl, size, userUid, useContrastLogo)
      })
    }

    function getAvatar(scope, imageEl, size, userUid, useContrastLogo) {
      imageEl.css('visibility', 'hidden')

      if (angular.isUndefined(userUid) && useContrastLogo) {
        scope.avatarUrl = $rootScope.canApplyDarkTheme
          ? CONTRAST_AVATAR_WHITE
          : CONTRAST_AVATAR
        setImageProperty(imageEl, size)
      } else {
        avatarFactory.getAvatarUrl(userUid, size).then(function (urlInfo) {
          if (urlInfo.url) {
            if (urlInfo.gravatar) {
              scope.avatarUrl = urlInfo.url
            } else {
              scope.avatarUrl = getRefreshUrl(urlInfo.url)
            }
          } else if (urlInfo.avatar) {
            scope.avatarUrl = urlInfo.avatar
          } else {
            scope.avatarUrl = DEFAULT_AVATAR
          }
          setImageProperty(imageEl, size)
        })
      }
    }

    //Refresh image by updating URL param
    function getRefreshUrl(url) {
      var base = url.split('?')[0],
        newTime = 'time=' + new Date().getTime(),
        newUrl = base + '?' + newTime

      if (url.indexOf('?') > -1) {
        var params = url.split('?')[1],
          paramsList = params.split('&')

        for (var i = 0; i < paramsList.length; i++) {
          if (paramsList[i].indexOf('time=') < 0) {
            newUrl += '&' + paramsList[i]
          }
        }
      }

      return newUrl
    }

    function setImageProperty(imageEl, size) {
      imageEl.attr('width', size + 'px')
      imageEl.attr('height', size + 'px')
      imageEl.css('visibility', '')
    }
  }
})()
